import { create } from 'zustand'

import { isUndefined } from '@/utils/isUndefined'

type AppState = {
  isMenuOpen: boolean
  clinicIds: string[] | null
  customerServiceNumber: string | null
  setClinicIds: (clinicIds: string[]) => void
  toggleMenu: (isVisible?: boolean) => void
  setCustomerServiceNumber: (number: string | null) => void
}

export const useAppStore = create<AppState>((set) => ({
  isMenuOpen: false,
  clinicIds: null,
  customerServiceNumber: null,
  toggleMenu: (isVisible = undefined) =>
    set((state) => ({ isMenuOpen: !isUndefined(isVisible) ? isVisible : !state.isMenuOpen })),
  setClinicIds: (clinicIds: string[]) => set({ clinicIds }),
  setCustomerServiceNumber: (number: string | null) => set({ customerServiceNumber: number }),
}))
